import { Injectable } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';

import {
    faGear as faGearSolid,
    faIndustry as faIndustrySolid,
    faUsers as faUsersSolid,
    faChartColumn as faChartColumnSolid,
    faEdit as faEditSolid,
    faHome as faHomeSolid,
    faCircleUser as faCircleUserSolid,
    faRectangleHistoryCircleUser as faRectangleHistorySolid,
    faClipboardListCheck as faClipboardListCheckSolid,
    faHouseFlag as faHouseFlagSolid,
    faRocketLaunch as faRocketLaunchSolid,
    faChartSimpleHorizontal as faChartSimpleHorizontalSolid,
    faLink as faLinkSolid,
    faSave as faSaveSolid,
    faTrash as faTrashSolid
} from '@fortawesome/pro-solid-svg-icons';

import {
    faGear as faGearRegular,
    faIndustry as faIndustryRegular,
    faUsers as faUsersRegular,
    faChartColumn as faChartColumnRegular,
    faEdit as faEditRegular,
    faHome as faHomeRegular,
    faCircleUser as faCircleUserRegular,
    faRectangleHistoryCircleUser as faRectangleHistoryRegular,
    faClipboardListCheck as faClipboardListCheckRegular,
    faHouseFlag as faHouseFlagRegular,
    faRocketLaunch as faRocketLaunchRegular,
    faChartSimpleHorizontal as faChartSimpleHorizontalRegular,
    faLink as faLinkRegular,
    faTrash as faTrashRegular,
    faSave as faSaveRegular
} from '@fortawesome/pro-regular-svg-icons';

import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
    faSveaskogSkotare as faSveaskogSkotareRegular,
    faSveaskogSkotareFilled as faSveaskogSkotareSolid
} from '@awesome.me/kit-3111ba4b6c/icons/kit/custom';

@Injectable({
    providedIn: 'root'
})
export class IconService {
    public readonly icons = {
        gear: { solid: faGearSolid, regular: faGearRegular },
        industry: { solid: faIndustrySolid, regular: faIndustryRegular },
        users: { solid: faUsersSolid, regular: faUsersRegular },
        chart: { solid: faChartColumnSolid, regular: faChartColumnRegular },
        edit: { solid: faEditSolid, regular: faEditRegular },
        home: { solid: faHomeSolid, regular: faHomeRegular },
        circleUser: { solid: faCircleUserSolid, regular: faCircleUserRegular },
        rectangleHistory: { solid: faRectangleHistorySolid, regular: faRectangleHistoryRegular },
        clipboard: { solid: faClipboardListCheckSolid, regular: faClipboardListCheckRegular },
        houseFlag: { solid: faHouseFlagSolid, regular: faHouseFlagRegular },
        machine: { solid: faRocketLaunchSolid, regular: faRocketLaunchRegular },
        columnChanger: { solid: faChartSimpleHorizontalSolid, regular: faChartSimpleHorizontalRegular },
        customMachine: { solid: faSveaskogSkotareSolid, regular: faSveaskogSkotareRegular },
        link: { solid: faLinkSolid, regular: faLinkRegular },
        save: { solid: faSaveSolid, regular: faSaveRegular },
        delete: { solid: faTrashSolid, regular: faTrashRegular },
    } as const;

    constructor(private library: FaIconLibrary) {
        this.registerAllIcons();
    }

    private registerAllIcons() {
        this.library.addIcons(
            faGearSolid, faIndustrySolid, faUsersSolid, faChartColumnSolid,
            faEditSolid, faHomeSolid, faCircleUserSolid, faRectangleHistorySolid,
            faClipboardListCheckSolid, faHouseFlagSolid,

            faGearRegular, faIndustryRegular, faUsersRegular, faChartColumnRegular,
            faEditRegular, faHomeRegular, faCircleUserRegular, faRectangleHistoryRegular,
            faClipboardListCheckRegular, faHouseFlagRegular,
            faRocketLaunchSolid, faRocketLaunchRegular,

            faSveaskogSkotareSolid,
            faSveaskogSkotareRegular
        );
    }

    getIcon(iconKey: keyof typeof this.icons, isActive: boolean = false) {
        const iconSet = this.icons[iconKey];

        if (typeof iconSet === 'object' && 'solid' in iconSet && 'regular' in iconSet) {
            return isActive ? iconSet.solid : iconSet.regular;
        }

        return iconSet;
    }

    getMenuIcon(iconKey: keyof typeof this.icons, isActive: boolean) {
        return this.getIcon(iconKey, isActive);
    }
}